// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2tbWS","row":"Node_row__1s948","label":"Node_label__3GZyg","footer":"Node_footer__2dsD7"};